import styled from "styled-components"

export const LoaderIcon = styled.div`
  position: relative;
  padding-left: 30px;
`
